export interface IAction {
  _id: string;
  code: string;
  name: string;
  description: string;
  type: string;
  link: string;
  order: number;
  icon: string;
  subActions: IAction[];
}

export type ActionCode =
  | "EXTERNAL_PROVIDERS_VIEW"
  | "USERS_VIEW"
  | "ROLES_VIEW"
  | "GOAL_TEMPLATES_VIEW"
  | "MANAGE_VIEW"
  | "HELP_SUPPORT_VIEW"
  | "PROGRAMS_VIEW"
  | "SETTINGS_VIEW"
  | "REWARDS_CONFIGURATION_VIEW"
  | "ACCOUNT_VIEW"
  | "DASHBOARD_VIEW"
  | "PARTICIPANTS_VIEW"
  | "RESOURCE_VIEW"
  | "SETTINGS_CLOSURE_SAVE"
  | "ORG_UNITS_VIEW"
  | "ORGANIZATION_LABELS_VIEW"
  | "ACTIONS_VIEW"
  | "EDUCATIONAL_RESOURCES_VIEW"
  | "CATEGORIES_VIEW"
  | "SETTINGS_CATALOG_VIEW"
  | "ACCOUNT_SETTINGS_VIEW"
  | "TERMS_VIEW";

export const ACTION_CODES: ActionCode[] = [
  "EXTERNAL_PROVIDERS_VIEW",
  "USERS_VIEW",
  "ROLES_VIEW",
  "GOAL_TEMPLATES_VIEW",
  "MANAGE_VIEW",
  "HELP_SUPPORT_VIEW",
  "PROGRAMS_VIEW",
  "SETTINGS_VIEW",
  "REWARDS_CONFIGURATION_VIEW",
  "ACCOUNT_VIEW",
  "DASHBOARD_VIEW",
  "PARTICIPANTS_VIEW",
  "RESOURCE_VIEW",
  "SETTINGS_CLOSURE_SAVE",
  "ORG_UNITS_VIEW",
  "ORGANIZATION_LABELS_VIEW",
  "ACTIONS_VIEW",
  "EDUCATIONAL_RESOURCES_VIEW",
  "CATEGORIES_VIEW",
  "SETTINGS_CATALOG_VIEW",
  "ACCOUNT_SETTINGS_VIEW",
  "TERMS_VIEW",
];

export type ActionType = "MENU_OPTION" | "OPTION";

export interface Action {
  _id: string;
  id: string;
  name: string;
  code: ActionCode;
  status: "ACTIVE" | "INACTIVE";
  description: string;
  type?: ActionType;
  link?: string;
  order?: number;
  icon?: string;
  subActions?: (string | Action)[];
  isDeleted: boolean;
  createdAt: string;
  updatedAt?: string;
  createdBy: string;
  updatedBy?: string;
}

export type ActionPayload = {
  name: string;
  code: ActionCode;
  status: "ACTIVE" | "INACTIVE";
  description: string;
  type?: ActionType;
  link?: string;
  order?: number;
  icon?: string;
  subActions?: string[];
  createdBy?: string;
  updatedBy?: string;
};
